<section id="openAccount">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Contact Us / Open an Account</h1>
      </div>
    </div>
  </div>
</section>

<section class="section2">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <p>Investing for Catholics is a wholly owned division of Index Fund Advisors, Inc. (IFA), a fee-only Independent Financial Advisor registered with the United States Securities and Exchange Commission.<sup>*</sup></p>

        <p>Investing for Catholics' (IFC) <strong>minimum account size is $100,000</strong>. Charles Schwab & Co., Inc. and Fidelity Investments have been selected as Index Fund Advisors' custodians. Custodians are independent financial institutions that hold client assets and provide confirmations of transactions and monthly reports. There is no ownership or management involvement by any custodian.</p>

        <p>If you already have a Charles Schwab or Fidelity Investments account (custodian accounts), it is a simple process for us to become your Investment Manager.  We also have forms to transfer your account from your current broker to one of these custodians.</p>

        <p>Your custodian account will be included in our "Master Account" at the institutional groups of those firms so that we can make transactions for you, but you will also have access through the custodian websites and the numerous branch offices of those firms nationwide or by phone.</p>

        <p>Statements (monthly) and confirmations (as they occur) will come to you from the custodian and Index Fund Advisors will provide you with a detailed analysis of your portfolio in electronic form every month and in hard-copy form every quarter.</p>

        <p>Before opening an account, we will provide you a client agreement and a copy of our ADV Part II, which will detail all relevant aspects of our business, including our asset based "fee-only" pricing schedule.</p>

        <p>Our corporate headquarters are located in Irvine, CA.</p>
        <p><small>* SEC registration does not constitute an endorsement of the firm by the Commission nor does it indicate that the adviser has attained a particular level of skill or ability.</small></p>
      </div>

    </div>
  </div>
</section>

<!-- <section id="map-area">
<div class="container-fluid">
  <div class="row">
    <div class="col-12 padding-0">
      <object style="border:0; height: 450px; width: 100%;" alt="Google Map" data="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3320.4620524480183!2d-117.86001148396029!3d33.67109814516465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcdef5a1ecc92b%3A0x91a352e03786aa25!2s19200+Von+Karman+Ave+%23150%2C+Irvine%2C+CA+92612!5e0!3m2!1sen!2sus!4v1541719846880"></object>
    </div>
  </div>
</div>
</section> -->

<div class="clearfix mt-5 mb-5"></div>

<section id="contact">
  <div class="contact-form">
    <div class="container">
      <div class="row justify-content-center">
        <div class="offset-top">
          <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="contact-block">
              <div class="section-header">
                <p class="btn btn-subtitle">Contact Us / Open Account</p>
                <h2 class="section-title">We're Here For Your Catholic Investing Needs</h2>
                <address>
                  <p><strong>Address:</strong> <br />19200 Von Karman Ave, Suite 150<br /> Irvine, CA 92612</p>
                </address>
                <p><strong>Phone:</strong> <a href="tel:888-815-5025"> (888) 815-5025</a></p>
                <p><strong>Email: </strong>
                <a data-name="mary" data-domain="ifa" data-tld="com" href="#" class="cryptedmail" onclick="window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld" title="email us"></a>
              </p>
            </div>

            <form id="contactForm" (ngSubmit)="contactFormSubmit()">
              @if (contactFormMessage.length>0) {
                <div id="form-messages" class="h3 text-center">{{contactFormMessage}}</div>
              }
              @if (!isSending) {
                <div class="hideform">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <input [(ngModel)]="name" (blur)="validateName()" type="text" class="form-control" id="name" name="name"
                          placeholder="Name" required="" data-error="Please enter your name">
                          <div class="error name">{{nameValidationText}}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input [(ngModel)]="email" (blur)="validateEmail()" type="text" placeholder="Email" id="email"
                            class="form-control" name="email" required="" data-error="Please enter your email">
                            <div class="error email">{{emailValidationText}}</div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <input [(ngModel)]="phone" type="phone" placeholder="Phone" id="phone" class="form-control"
                              required="" data-error="Please enter your phone number" name="phone">
                              <div class="error phone"></div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <textarea [(ngModel)]="message" class="form-control" id="message" placeholder="Message" rows="7"
                              data-error="Write your message" required="" name="message"></textarea>
                              <div class="error message"></div>
                            </div>
                            <div class="text-center my-5"><div #captchaRef2></div></div>
                            <!--<div class="text-center mt-5 mb-5"><div class="g-recaptcha" data-sitekey="6LdgIHsUAAAAADoZREupxP-6xHArHZS4h7DO4ns3"></div></div>-->
                            -<div class="submit-button text-center">
                            <button class="btn btn-primary disabled" id="submit" type="submit" style="pointer-events: all; cursor: pointer;">Submit</button>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>